module.exports = __webpack_public_path__ + "img/45.941396cc.jpg";